import { gql } from "apollo-boost";

export const MODIFY_CUSTOMER = gql`
  mutation modifyCustomer($modification: Modification) {
    modifyCustomer(modification: $modification) {
      email
    }
  }
`;
